import React from "react";
import { SuccessPage } from "../../../components/componentIndex";
import SuccessBGImg from '../../../assets/images/success-bg.svg';
import callToSchedule from '../../../assets/images/call-to-schedule.svg';

const SuccessMsg = ({ handleNextEvent, formData, isCallUS }) => {


    const successMsgObj = {
        img: SuccessBGImg,
        mainTitle: 'Questionnaire complete',
        title: 'Congrats 🎉',
        message: 'You are one step closer to open access colonoscopy. Please allow up to 48 hours for us to review your questionnaire. We will notify you once your answers are reviewed.',
        btnName: 'Visits',
        btnType: 'button',
        redirectUrl: '/visits',
        btnClassName: 'btn-primary visits-btn',
        isDisabled: true
    }

    let deniedObj = {
        img:callToSchedule,
        status: 'Denied',
        mainTitle: 'Call to schedule',
        title: 'Schedule an appointment',
        message: 'Based on your answers, you will need an office visit before scheduling your colonoscopy.',
        btnName: 'Call us',
        btnType: 'button',
        redirectUrl: '/visits',
        btnClassName: 'btn-primary visits-btn',
        isDisabled: true
    }
    return (
        <SuccessPage successMsgData={successMsgObj} deniedObj={deniedObj} handleNextEvent={handleNextEvent} isCallUS={isCallUS} />

    )
};

export default SuccessMsg;